import ReactGA from 'react-ga4';

// Initialize Google Analytics with your GA4 Measurement ID
ReactGA.initialize('G-VH79MF7PBS');

// Export the ReactGA instance to use throughout your app
export default ReactGA;